import EditInvoice from "../../views/Invoices/EditInvoice";

const EditInvoicePage = () => {
  return <EditInvoice />;
};

export default EditInvoicePage;
